<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>文章管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="文章标题"
							clearable @change="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange" size="mini">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增文章</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="sort" label="排序" align="center" />
			<el-table-column prop="title" label="文章标题" align="center" />
			<el-table-column prop="default_hot_num" label="文章封面" align="center" width="200">
				<template slot-scope="scope">
					<div>
						<template v-if="
                Array.isArray(JSON.parse(scope.row.article_imgs)) &&
                JSON.parse(scope.row.article_imgs).length > 1
              ">
							<el-image v-for="(img, index) in JSON.parse(scope.row.article_imgs)" :key="index"
								style="width: 50px; height: 50px; margin-right: 5px" :src="img"
								:preview-src-list="JSON.parse(scope.row.article_imgs)" />
						</template>
						<template v-else-if="
                Array.isArray(JSON.parse(scope.row.article_imgs)) &&
                JSON.parse(scope.row.article_imgs).length === 1
              ">
							<el-image style="width: 50px; height: 50px; margin-right: 5px"
								:src="JSON.parse(scope.row.article_imgs)[0]"
								:preview-src-list="[JSON.parse(scope.row.article_imgs)[0]]" />
						</template>
						<template v-else>
							<div class="image-slot">
								<span style="line-height: 50px">暂无图片</span>
							</div>
						</template>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="url" label="文章地址" align="center">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" style="color: #409eff">{{
            scope.row.url
          }}</a>
				</template>
			</el-table-column>
			<el-table-column prop="default_hot_num" label="初始热度" align="center" />
			<el-table-column prop="hot_num" label="点击热度" align="center" />
			<el-table-column prop="created_at" label="创建时间" align="center" />
			<el-table-column prop="updated_at" label="更新时间" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
					<!-- <el-button
            @click.native.prevent="copyClick(scope.row)"
            type="info"
            size="small"
          >
            复制
          </el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="文章标题" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="公众号地址" prop="url">
							<el-input v-model="form.url" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="初始热度" prop="default_hot_num">
							<el-input v-model="form.default_hot_num" autocomplete="off" placeholder="请输入" />
						</el-form-item>
						<el-form-item label="点击热度" prop="hot_num">
							<el-input v-model="form.hot_num" autocomplete="off" disabled placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="适用小区" prop="xiaoqu_id">
							<el-select v-model="form.xiaoqu_id" placeholder="请选择" style="width: 100%" filterable
								multiple>
								<el-option v-for="item in communityData" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="适用日期" prop="">
							<el-date-picker v-model="form.date" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" align="right"
								range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
								:picker-options="pickerOptions" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="资讯分类" required>
							<el-select v-model="form.category_ids" placeholder="请选择" style="width: 100%"
								@change="getCategory" filterable multiple>
								<el-option v-for="item in classArr" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="标签" required>
							<el-select v-model="form.tag_ids" placeholder="请选择" style="width: 100%"
								@change="getCategory" filterable multiple>
								<el-option v-for="item in tagGroup" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
            <el-form-item label="文章状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->

					<el-col :span="24">
						<el-form-item label="封面图片">
							<el-upload :class="{ uploadSty: showBtnImg, disUploadSty: noneBtnImg }" ref="upload"
								list-type="picture-card" :limit="limit" :action="uploadImgUrl" :headers="headers"
								:on-change="imgChange" :file-list="conTypeFiles" :on-success="handleAvatarSuccess"
								:on-remove="handleRemove" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed"
								:on-preview="handlePictureCardPreview" disabled>
								<i class="el-icon-picture-outline avatar-uploader-icon" @click="uploadPicIcon"></i>
							</el-upload>
							<div style="color: #999; margin-top: -2vh">
								图片大小建议400*300
							</div>
							<el-dialog :visible.sync="dialogVisible" style="z-index: 9999">
								<img width="100%" :src="imageUrl" alt="" />
							</el-dialog>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="图片地址" v-for="(item, index) in conTypeArr" :key="index">
							<div class="chooseImg">
								<el-button type="info" @click="chooseImg(index)">选择图片</el-button>
								<el-input v-model="item.url" autocomplete="off" placeholder="请输入">
								</el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibles" style="z-index: 9999">
			<img width="100%" :src="imageUrl" alt="" />
		</el-dialog>
		<el-dialog :title="copyTit" :visible.sync="copyIf" :close-on-click-modal="false" width="45%"
			class="dialogHeightX global-dialog-position" :before-close="copyout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: 10vh">
			<el-form ref="copyForm" :model="copyForm" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="适用小区" prop="xiaoqu_id">
							<el-select v-model="copyForm.xiaoqu_id" placeholder="请选择" style="width: 100%" filterable>
								<el-option v-for="item in communityData" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="copySub">确 定</el-button>
				<!-- <el-button @click="getout">取 消</el-button> -->
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -7vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
				<!-- <el-button @click="getout">取 消</el-button> -->
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getarticleList,
		addArticle,
		editArticle,
		deleteCity,
	} from "../../api/article";
	import {
		getclassifyList
	} from "../../api/classify";
	import {
		getcommunityList
	} from "../../api/community";
	import {
		getCookie
	} from "../../utils/util";
	// import { labelChildList } from "../../api/labelChild";
	import {
		tagSeleList
	} from "../../api/labelChild";
	import imgUpload from "../../components/uploadImg.vue";

	export default {
		mixins: [tableCommon],
		components: {
			imgUpload,
		},
		data() {
			return {
				upImg: false,
				dialogVisibles: false,
				dialogVisible: false,
				regionTypes: [{
						label: 1,
						text: "显示",
					},
					{
						label: 0,
						text: "关闭",
					},
				],
				limit: 3,
				showBtnImg: true,
				noneBtnImg: false,
				// 图片数组
				conTypeFiles: [],
				// 请求地址api
				api: {
					list: getarticleList,
					add: addArticle,
					del: deleteCity,
					edit: editArticle,
				},
				// 规则验证
				rules: {
					category_ids: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}, ],
					title: [{
						required: true,
						message: "请输入名称",
						trigger: "blur"
					}],
					status: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 分类数组
				classArr: [],
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
				},
				tableData: [],
				// 小区数组
				xiaoquArr: [],
				communityData: [],
				// 图片
				imageUrl: "",
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				// 处理图片数组
				dealPic: [],
				// 标签下拉列表
				tagGroup: [],
				// 图片组
				conTypeArr: [],
				imgFirst: false,
				imgSecond: false,
				imgThird: false,
				copyForm: {},
				copyIf: false,
				// 复制标题
				copyTit: "",
			};
		},
		mounted() {
			this.getclassifyLists();
			this.getcommunityLists();
			this.labelChildLists();
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
			conTypeArr: {
				handler(newArr) {
					this.conTypeFiles = newArr.filter((item) => item.url !== "");
					this.noneBtnImg = this.conTypeFiles.length >= this.limit;
				},
				deep: true,
			},
		},
		methods: {
			changeDate() {
				this.$forceUpdate()
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			copyClick(res) {
				this.copyForm = JSON.parse(JSON.stringify(res));
				delete this.copyForm.created_at;
				delete this.copyForm.xiaoqu_id;
				delete this.copyForm.id;
				if (this.copyForm.category_ids) {
					const stt = this.copyForm.category_ids.split(",").map(Number);
					this.copyForm.category_ids = stt;
				}
				if (this.copyForm.tag_ids) {
					const stts = this.copyForm.tag_ids.split(",").map(Number);
					this.copyForm.tag_ids = stts;
				}
				//   this.conTypeFiles.push({ pic: this.copyForm.article_imgs });
				if (this.copyForm.article_imgs) {
					this.copyForm.article_imgs.map((res) => {
						this.conTypeFiles.push({
							url: res
						});
					});
				}
				this.conTypeArr = JSON.parse(JSON.stringify(this.conTypeFiles));
				if (this.conTypeArr.length < 3) {
					const difference = 3 - this.conTypeArr.length;
					for (let i = 0; i < difference; i++) {
						this.conTypeArr.push({
							url: ""
						}); // 替换"your_default_url"为您想要添加的默认URL
					}
				}
				this.noneBtnImg = this.conTypeFiles.length >= this.limit;
				this.copyIf = true;
				this.copyTit = `${this.copyForm.title}`;
				this.actionType = "add";
			},
			copySub() {
				let paths = this.conTypeFiles.map(function(obj) {
					if (obj.url) {
						return obj.url;
					}
				});
				// this.form.article_imgs = paths;
				this.copyForm.article_imgs = paths.filter(
					(item) => item !== undefined && item !== null
				);
				delete this.copyForm.duration;
				delete this.copyForm.video_img;
				delete this.copyForm.xiaoqu_name;
				delete this.copyForm.created_at;
				if (this.copyForm.category_ids) {
					const str = this.copyForm.category_ids.join(",");
					this.copyForm.category_ids = str;
				}
				if (this.copyForm.tag_ids) {
					const strs = this.copyForm.tag_ids.join(",");
					this.copyForm.tag_ids = strs;
				}
				try {
					// 提交表单
					// this.submitForm(this.copyForm.category_ids);
					addArticle(this.copyForm).then((response) => {
						this.addOrEditOpen = false;
						this.copyIf = false;
						this.$message.success("添加成功");
						this.initList();
					});
					this.conTypeFiles = [];
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();

						this.conTypeArr[0].url = this.$refs.imgUpload.faData.url;
					} else if (
						this.imgSecond &&
						this.$refs.imgUpload.faData.url !== undefined
					) {
						this.$refs.imgUpload.findTrue();

						this.conTypeArr[1].url = this.$refs.imgUpload.faData.url;
					} else if (
						this.imgThird &&
						this.$refs.imgUpload.faData.url !== undefined
					) {
						this.$refs.imgUpload.findTrue();

						this.conTypeArr[2].url = this.$refs.imgUpload.faData.url;
					}
					this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg(res) {
				if (res === 0) {
					this.imgSecond = false;
					this.imgThird = false;
					this.imgFirst = true;
				} else if (res === 1) {
					this.imgFirst = false;
					this.imgThird = false;
					this.imgSecond = true;
				} else if (res === 2) {
					this.imgFirst = false;
					this.imgSecond = false;
					this.imgThird = true;
				}
				this.upImg = true;
			},
			// 预览
			handlePictureCardPreview(file) {
				this.imageUrl = file.url;
				this.$nextTick(() => {
					this.dialogVisibles = true;
				});
			},
			// 标签下拉
			labelChildLists() {
				const select = {
					select: 1,
					type: 3,
				};
				tagSeleList(select).then((res) => {
					this.tagGroup = res.data;
				});
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				// this.handleEdit();
				this.actionType = "edit";
				delete this.form.duration;
				delete this.form.video_img;
				delete this.form.xiaoqu_name;
				delete this.form.created_at;
				// const { city_name, company_name, ...rest } = this.form;
				// this.form = rest;
				editArticle(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			imgChange(file, fileList) {
				this.noneBtnImg = fileList.length >= this.limit;
			},
			getCategory(res) {},
			// 移除照片
			handleRemove(res, req) {
				this.conTypeFiles = req;
				this.conTypeArr = JSON.parse(JSON.stringify(req));
				if (this.conTypeArr.length < 3) {
					const difference = 3 - this.conTypeArr.length;
					for (let i = 0; i < difference; i++) {
						this.conTypeArr.push({
							url: ""
						}); // 替换"your_default_url"为您想要添加的默认URL
					}
				}
				this.noneBtnImg = req.length >= this.limit;
			},
			handleExceed(files, fileList) {
				// console.log(files, fileList);
				this.$message.error(` 一次最多上传3张! `);
			},
			// 上传图片
			handleAvatarSuccess(res, file, list) {
				this.imageUrl = res.data.path;
				this.form.article_imgs = this.imageUrl;
				this.conTypeFiles.push({
					url: file.response.data.path
				});
				for (let i = 0; i < this.conTypeArr.length; i++) {
					if (!this.conTypeArr[i].url || this.conTypeArr[i].url === "") {
						this.conTypeArr[i].url = file.response.data.path;
						break; // 找到第一个满足条件的元素后，中断循环
					}
				}
				//   this.form.sales_img = this.imageUrl;
				//   console.log(this.imageUrl);
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/gif" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 1000;

				if (!isJPG) {
					this.$message.error("图片格式不对");
				}
				return isJPG;
			},
			// 获取分类数组
			getclassifyLists() {
				getclassifyList().then((res) => {
					this.classArr = res.data.records;
				});
			},
			// 获取小区分类
			getcommunityLists() {
				const form = {
					select: 1,
				};
				getcommunityList(form).then((res) => {
					this.xiaoquArr = res.data.records;
					let jsonArray = JSON.stringify(this.xiaoquArr);
					let jsonArrays = JSON.parse(jsonArray);
					let arr = {
						id: 0,
						title: "通用"
					};
					jsonArrays.unshift(arr);
					let newXiaoarr = JSON.stringify(jsonArrays);
					// this.communityData = JSON.parse(newXiaoarr);
					this.communityData = JSON.parse(newXiaoarr).map(({
						id,
						title
					}) => ({
						id,
						title,
					}));
				});
			},
			// 重置
			reset() {
				this.form = {
					status: undefined,
					title: undefined,
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.form.type = 2;
					this.form.status = 1;
					this.conTypeArr = [{
						url: ""
					}, {
						url: ""
					}, {
						url: ""
					}];
					this.$refs.form.clearValidate();
					// this.conTypeFiles = [{ url: "" }, { url: "" }, { url: "" }];
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log(this.form);
				if (this.form.xiaoqu_id) {
					const stt = this.form.xiaoqu_id.split(",").map(Number);
					this.form.xiaoqu_id = stt;
				}
				if (this.form.category_ids) {
					const stt = this.form.category_ids.split(",").map(Number);
					this.form.category_ids = stt;
				}
				if (this.form.suit_time_begin && this.form.suit_time_end) {
					this.form.date = [this.form.suit_time_begin,this.form.suit_time_end];
				}
				if (this.form.tag_ids) {
					const stts = this.form.tag_ids.split(",").map(Number);
					this.form.tag_ids = stts;
				}
				//   this.conTypeFiles.push({ pic: this.form.article_imgs });
				if (this.form.article_imgs) {
					let arcImg = JSON.parse(this.form.article_imgs)
					arcImg.map((res) => {
						this.conTypeFiles.push({
							url: res
						});
					});
				}
				this.conTypeArr = JSON.parse(JSON.stringify(this.conTypeFiles));
				if (this.conTypeArr.length < 3) {
					const difference = 3 - this.conTypeArr.length;
					for (let i = 0; i < difference; i++) {
						this.conTypeArr.push({
							url: ""
						}); // 替换"your_default_url"为您想要添加的默认URL
					}
				}
				this.noneBtnImg = this.conTypeFiles.length >= this.limit;
				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				let paths = this.conTypeFiles.map(function(obj) {
					if (obj.url) {
						return obj.url;
					}
				});
				// this.form.article_imgs = paths;
				this.form.article_imgs = paths.filter(
					(item) => item !== undefined && item !== null
				);
				delete this.form.duration;
				delete this.form.video_img;
				delete this.form.xiaoqu_name;
				delete this.form.created_at;
				
				if (this.form.date.length) {
					this.form.suit_time_begin = this.form.date[0];
					this.form.suit_time_end = this.form.date[1];
					delete this.form.date;
				}
				
				if (this.form.xiaoqu_id) {
					const str = this.form.xiaoqu_id.join(",");
					this.form.xiaoqu_id = str;
				}
				if (this.form.category_ids) {
					const str = this.form.category_ids.join(",");
					this.form.category_ids = str;
				}
				if (this.form.tag_ids) {
					const strs = this.form.tag_ids.join(",");
					this.form.tag_ids = strs;
				}
				try {
					// 提交表单
					this.submitForm(this.form.category_ids);
					this.conTypeFiles = [];
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.conTypeFiles = [];
				this.$refs.form.clearValidate();
				// this.$refs.addOrEditOpen.scrollTop = 0;
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/information/article.vue